export class InvalidSubmissionTypeError extends Error {
    constructor(type: string) {
        super(`${type} is not a valid submission type`);
    }
}
